import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@mui/material';

import { optionToDisplay } from '@/utils/stringUtils';

import { FormikRadioGroup } from '@/components/formik/FormikRadioGroup';
import { BANK_ACCOUNT_TYPES } from '@/components/paymentMethod/config';

import type { TPaymentMethodListItem } from '@/types/wallet';

import { selectExistingStyles as styles } from './PaymentMethod.styles';

type TSelectExistingProps = {
  methods: TPaymentMethodListItem[];
  disabled: Set<number> | undefined;
};

export const SelectExistingMethod = ({ methods, disabled }: TSelectExistingProps) => {
  const { t } = useTranslation();

  const options = useMemo(
    () =>
      methods.map(({ id, name, last4, bankAccountType }) => ({
        value: String(id),
        label: name,
        disabled: disabled?.has(id),
        accountType: optionToDisplay(BANK_ACCOUNT_TYPES, bankAccountType, t),
        last4,
      })),
    [methods, disabled, t],
  );

  return (
    <FormikRadioGroup
      variant="fullWidth"
      name="data.paymentMethodId"
      sx={styles.root}
      options={options}
      renderOption={({ label, last4, accountType }) => (
        <>
          <Grid>
            <Typography sx={styles.name} noWrap>
              {label}
            </Typography>
            <Typography sx={styles.last4}>*****{last4}</Typography>
          </Grid>

          <Typography variant="body2">{accountType}</Typography>
        </>
      )}
    />
  );
};
